module.exports = __webpack_public_path__ + "img/bg-404-mobile.0351d6e5.svg";